import { Filter } from '@fabric-ui/components';
import { DwQueryRequest, Field } from './QueryObject.types';

export enum DashboardMode {
  View = 'VIEW',
  Edit = 'EDIT',
}

export type WidgetTitle = {
  title: string;
};

export enum WidgetCategory {
  Bar = 'BAR_CATEGORY', // stacked,line are metadata
  Pie = 'PIE_CATEGORY', // pie/donut are metadata
  Table = 'TABLE_CATEGORY',
  Line = 'LINE_CATEGORY',
  Tile = 'TILE_CATEGORY',
  Text = 'TEXT_CATEGORY',
  Venn = 'VENN_CATEGORY',
  // ...
}

export const HistoricalFilterMode = {
  CURRENT: 'CURRENT',
  HISTORICAL: 'HISTORICAL',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type HistoricalFilterMode = (typeof HistoricalFilterMode)[keyof typeof HistoricalFilterMode];

export type Coords = {
  x: number;
  y: number;
  h: number;
  w: number;
};

export type BaseWidget = {
  id?: string;
  requests: DwQueryRequest[];
  definition: WidgetDefinition;
  drillDownHierarchy?: {
    fields: Field[];
    activeIndex: number;
    drillDownValues: string[];
    expendedIds?: string[];
    notOthersDrillDownValues?: string[];
  };
  binnedTimeBuckets?: boolean;
  queryAggIfCollapseOptimization?: boolean;
  historicalFilterMode?: HistoricalFilterMode;
};

export type Custom = {
  crossTableView: boolean;
};

export type WidgetDefinition = {
  coords: Coords;
  title: WidgetTitle;
};

export type CommonWidgetProps = {
  setWidget?: any;
  data?: Record<string, any>[];
  responseTotals?: Record<string, any>;
  isLoading?: boolean;
  selected?: any[];
  onSelect?: (...v: any[]) => void;
  globalFilters?: Filter;
};

export type Data = string | number | boolean | string[] | null | undefined;
